import '.ac{flex-shrink:0;}.ssr-plugin'
import '.c2{width:20rem;}.ssr-plugin'
import '.u{border:var(--border-subtle);}.ssr-plugin'
import '.c3{background-color:var(--palette-beige-100);}.ssr-plugin'
import '.as{border-radius:1.25rem;}.ssr-plugin'
import '.ae{padding:1rem;}.ssr-plugin'
import '.a{display:flex;}.ssr-plugin'
import '.c4{gap:4rem;}.ssr-plugin'
import '.aq{align-items:flex-start;}.ssr-plugin'
import { Style, styled } from 'inlines'
import { Children, isValidElement, PropsWithChildren, ReactNode } from 'react'
import useMediaQuery from '@app/util/useMediaQuery'
import { LeftSidebarMobile } from './LeftSidebar.mobile'

interface SidebarProps extends PropsWithChildren {
  style?: Style
  collapsedButtonLabel?: string
}

const Sidebar = ({ children, style }: SidebarProps) => {
  return (
    <styled.aside className="ac c2 u c3 as ae"
      style={{
        ...style,
      }}
    >
      {children}
    </styled.aside>
  )
}

const LeftSidebarRoot = ({ children }: PropsWithChildren) => {
  const isMobile = useMediaQuery()
  const childrenArray = Children.toArray(children)
  let sidebar: ReactNode = null
  const content: ReactNode[] = []

  for (const child of childrenArray) {
    if (isValidElement(child)) {
      if (child.type === Sidebar) {
        sidebar = child
      } else {
        content.push(child)
      }
    }
  }

  if (isMobile) {
    return <LeftSidebarMobile sidebar={sidebar} content={content} />
  }

  return (
    <div className="a c4 aq"
    >
      {sidebar}
      {content}
    </div>
  )
}

export const LeftSidebar = Object.assign(LeftSidebarRoot, {
  Sidebar,
})
